import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { Calendar } from 'react-date-range';
import { format, toDate } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import {
    WEB_ENTRY_DATE,
    CLASS_NAME,
    CALENDAR_MENU,
} from '../../../constants/shared/WebEntryConstants';

const { EMPTY_DATE, WEB_ENTRY_PANEL_DATE_FORMAT } = WEB_ENTRY_DATE;

const DatePicker = ({
    date,
    datePickerRef,
    handleChange,
    handleKeyDown,
    handleDropdownToggle,
    isOpen,
    datePickerClassName,
    showAllStudentsCheckbox,
}) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleChangeHandler = dateValue => {
        handleChange(dateValue, isChecked);
        handleDropdownToggle(false);
    };

    const handleCheckBoxChange = () => {
        setIsChecked(!isChecked);
    };

    useEffect(() => {
        if (!isOpen && isChecked) {
            handleCheckBoxChange();
        }
    }, [isOpen]);

    return (
        <Dropdown
            id="datePicker"
            className="dateRangeDropdown squared date-picker"
            onToggle={handleDropdownToggle}
            show={isOpen}
        >
            <Dropdown.Toggle className="squared calendar-toggle" onKeyDown={handleKeyDown}>
                <div
                    className={`d-m-y date-global-style ${
                        date ? 'bold' : ''
                    } ${datePickerClassName} ${CLASS_NAME.PREVENT_VALIDATION}`}
                    ref={datePickerRef}
                >
                    {date ? format(new Date(date), WEB_ENTRY_PANEL_DATE_FORMAT) : EMPTY_DATE}
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className={`squared ${CALENDAR_MENU}`}>
                {showAllStudentsCheckbox && (
                    <label htmlFor="date-picker-checkbox" className="checkbox-container">
                        <input
                            className="checkbox-input"
                            type="checkbox"
                            onChange={handleCheckBoxChange}
                            checked={isChecked}
                        />
                        <span className="checkbox-text">
                            Use date for all students in the grade
                        </span>
                    </label>
                )}
                <Calendar date={date} onChange={handleChangeHandler} maxDate={toDate(Date.now())} />
            </Dropdown.Menu>
        </Dropdown>
    );
};

DatePicker.defaultProps = {
    date: null,
    datePickerClassName: '',
    handleKeyDown: () => {},
    datePickerRef: null,
    showAllStudentsCheckbox: false,
};

DatePicker.propTypes = {
    date: PropTypes.instanceOf(Date),
    handleChange: PropTypes.func.isRequired,
    handleDropdownToggle: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    datePickerClassName: PropTypes.string,
    datePickerRef: PropTypes.object,
    handleKeyDown: PropTypes.func,
    showAllStudentsCheckbox: PropTypes.bool,
};

export default DatePicker;
